import { render, staticRenderFns } from "./RegisterWelcome.vue?vue&type=template&id=81f67cba&scoped=true&"
import script from "./RegisterWelcome.vue?vue&type=script&lang=js&"
export * from "./RegisterWelcome.vue?vue&type=script&lang=js&"
import style0 from "./RegisterWelcome.vue?vue&type=style&index=0&id=81f67cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f67cba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VAlert,VBtn,VIcon,VStepper,VStepperContent,VStepperItems})
